module.exports = "<span class=\"tooltip-trigger\" v-el:trigger>\n\t<slot></slot>\n</span> \n<div class=\"tooltip fade in {{tooltipAlignment}}\" v-el:tooltip>\n\t<div class=\"tooltip-inner\">\n\t\t<div class=\"tooltip-arrow\"></div>\n\t  <div class=\"tooltip-content\">\n\t    <span v-html=\"text\" v-if=\"text\"></span>\n\t    <slot name=\"content\" v-if=\"!text\"></slot>\n\t  </div>\n\t</div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/tooltip/tooltip.html
// module id = 79
// module chunks = 0